import React from "react";
import {Outlet} from "react-router-dom";
import AdminClientBillingNavTab from "./AdminClientBillingNavTab";

function AdminClientBilling() {
    return (
        <section className="section-bg-color setting_tab"
                 style={{minHeight: 'calc(100vh - 119px)', overflowX: 'hidden', marginTop:"6vh"}}>
            <div className="custom_container">
                <div className="row">

                    <AdminClientBillingNavTab/>

                    <div className="col-lg-10 col-md-9">
                        <div className="tab-content mt-0 bg_transparent" id="nav-tabContent"
                             style={{minHeight: 'calc(100vh - 259px)', marginBottom: '30px'}}>

                            <Outlet/>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AdminClientBilling;